import { render, staticRenderFns } from "./GroupSelectionAuthors.vue?vue&type=template&id=7c116eb9&scoped=true&"
import script from "./GroupSelectionAuthors.vue?vue&type=script&lang=js&"
export * from "./GroupSelectionAuthors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c116eb9",
  null
  
)

export default component.exports